import { createSlice } from "@reduxjs/toolkit";
import { fetchUserProfileById, updateUserProfile } from "./userProfile.actions";

const slice = createSlice({
  name: "userProfile",
  initialState: {
    user: null,
    awsToken: "",
    shouldFetchUser: true,
    isAuthenticated: false,
  },
  reducers: {
    setAwsToken(state, action) {
      state.awsToken = action.payload;
    },
    setIsAuthenticated(state, action) {
      state.isAuthenticated = action.payload;
    },
    setShouldFetchUser(state, action) {
      state.shouldFetchUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfileById.fulfilled, (state, action) => {
        if (action.payload) state.user = action.payload;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        if (!action.payload) return;
        const { name, profilePicUrl, deployToken } = action.payload;
        state.user = action.payload.id
          ? { ...state.user, name, profilePicUrl, deployToken }
          : state.user;
      });
  },
});

export default slice;

export const { name, actions, reducer } = slice;
